"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "170",
    height: "170",
    viewBox: "0 0 170 170"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M138.13,170H31.87a3.54,3.54,0,1,1,0-7.08H138.13a3.54,3.54,0,0,1,0,7.08Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.23,145.63a10.57,10.57,0,0,1-7.52,3.12H21.25v3.54a3.53,3.53,0,0,0,3.54,3.54H145.21a3.53,3.53,0,0,0,3.54-3.54V107.11Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M152.29,0H17.71a3.53,3.53,0,0,0-3.54,3.54V138.12a3.54,3.54,0,0,0,3.54,3.55h85a3.54,3.54,0,0,0,2.51-1l49.57-49.58a3.54,3.54,0,0,0,1-2.51v-85A3.53,3.53,0,0,0,152.29,0Zm-46,129.58V92.08h37.49Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85,116.23a9.5,9.5,0,0,1-9.29-7.56H52.87a1.94,1.94,0,0,1,0-3.87,5.63,5.63,0,0,0,5.63-5.62v-17a26.57,26.57,0,0,1,15.19-24,11.38,11.38,0,0,1,22.62,0,26.6,26.6,0,0,1,15.2,24v17a5.62,5.62,0,0,0,5.62,5.62,1.94,1.94,0,0,1,0,3.87H94.29A9.5,9.5,0,0,1,85,116.23Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85,48.24a11.29,11.29,0,0,1,11.2,10,26.31,26.31,0,0,1,15.18,23.88v17a5.76,5.76,0,0,0,5.75,5.75,1.81,1.81,0,1,1,0,3.62H94.19a9.37,9.37,0,0,1-18.38,0H52.87a1.81,1.81,0,1,1,0-3.62,5.76,5.76,0,0,0,5.75-5.75v-17A26.29,26.29,0,0,1,73.8,58.29a11.29,11.29,0,0,1,11.2-10M85,48A11.49,11.49,0,0,0,73.57,58.12a26.71,26.71,0,0,0-15.2,24.05v17a5.5,5.5,0,0,1-5.5,5.5,2.06,2.06,0,0,0,0,4.12H75.61a9.61,9.61,0,0,0,18.78,0h22.74a2.06,2.06,0,1,0,0-4.12,5.51,5.51,0,0,1-5.5-5.5v-17a26.72,26.72,0,0,0-15.2-24.05A11.49,11.49,0,0,0,85,48Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.87,61.43a1.94,1.94,0,0,1-1.93-1.93A22.75,22.75,0,0,1,73.66,36.77a1.94,1.94,0,0,1,0,3.88A18.87,18.87,0,0,0,54.81,59.5,1.94,1.94,0,0,1,52.87,61.43Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.66,36.9a1.81,1.81,0,0,1,0,3.62,19,19,0,0,0-19,19,1.81,1.81,0,0,1-3.62,0,22.63,22.63,0,0,1,22.6-22.6m0-.25A22.88,22.88,0,0,0,50.81,59.5a2.06,2.06,0,0,0,4.12,0A18.75,18.75,0,0,1,73.66,40.77a2.06,2.06,0,0,0,0-4.12Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.54,61.43A1.94,1.94,0,0,1,39.6,59.5,34.1,34.1,0,0,1,73.66,25.43a1.94,1.94,0,1,1,0,3.87A30.23,30.23,0,0,0,43.47,59.5,1.94,1.94,0,0,1,41.54,61.43Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.66,25.56a1.81,1.81,0,1,1,0,3.62A30.34,30.34,0,0,0,43.35,59.5a1.82,1.82,0,0,1-3.63,0A34,34,0,0,1,73.66,25.56m0-.25A34.23,34.23,0,0,0,39.47,59.5a2.07,2.07,0,0,0,4.13,0A30.1,30.1,0,0,1,73.66,29.43a2.06,2.06,0,1,0,0-4.12Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M117.13,61.43a1.94,1.94,0,0,1-1.94-1.93A18.86,18.86,0,0,0,96.34,40.65a1.94,1.94,0,0,1,0-3.88A22.75,22.75,0,0,1,119.06,59.5,1.94,1.94,0,0,1,117.13,61.43Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.34,36.9a22.63,22.63,0,0,1,22.6,22.6,1.81,1.81,0,0,1-3.62,0,19,19,0,0,0-19-19,1.81,1.81,0,0,1,0-3.62m0-.25a2.06,2.06,0,0,0,0,4.12A18.75,18.75,0,0,1,115.07,59.5a2.06,2.06,0,0,0,4.12,0A22.88,22.88,0,0,0,96.34,36.65Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M128.46,61.43a1.94,1.94,0,0,1-1.93-1.93A30.23,30.23,0,0,0,96.34,29.3a1.94,1.94,0,1,1,0-3.87A34.1,34.1,0,0,1,130.4,59.5,1.94,1.94,0,0,1,128.46,61.43Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.34,25.56A34,34,0,0,1,130.28,59.5a1.82,1.82,0,0,1-3.63,0A30.34,30.34,0,0,0,96.34,29.18a1.81,1.81,0,0,1,0-3.62m0-.25a2.06,2.06,0,0,0,0,4.12A30.1,30.1,0,0,1,126.4,59.5a2.07,2.07,0,0,0,4.13,0A34.23,34.23,0,0,0,96.34,25.31Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106.25,131.08a1.42,1.42,0,0,1-.57-.12,1.5,1.5,0,0,1-.93-1.38V92.08a1.5,1.5,0,0,1,1.5-1.5h37.49a1.5,1.5,0,0,1,1.06,2.56l-37.49,37.5A1.53,1.53,0,0,1,106.25,131.08Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M143.74,92.08l-37.49,37.5V92.08h37.49m0-3H106.25a3,3,0,0,0-3,3v37.5a3,3,0,0,0,1.85,2.77,3.06,3.06,0,0,0,1.15.23,3,3,0,0,0,2.12-.88l37.49-37.5a3,3,0,0,0-2.12-5.12Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;